import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IWhistleBlowChannelEditItem extends IEditItem {
    pageName: string;
    privacyPolicyUrl: string;
    adminUsers: IModifyUser[];
    modifyUser: IModifyUser;
}

export class WhistleBlowChannelEditItem extends EditItem implements IWhistleBlowChannelEditItem {
    pageName: string;
    privacyPolicyUrl: string;
    adminUsers: ModifyUser[];
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: IWhistleBlowChannelEditItem);
    constructor(obj?: any) {
        super(obj);
        this.pageName = obj && obj.pageName || "";
        this.privacyPolicyUrl = obj && obj.privacyPolicyUrl || "";
        this.adminUsers = Base.getTypedArray(obj ? obj.adminUsers : null, ModifyUser);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}